import React from 'react';
import SupplierList from '../../components/Suppliers/SupplierList';

const SuppliersPage: React.FC = () => {
    return <SupplierList />;
};

export default SuppliersPage; 